import jQuery from "jquery";

export default function login() {
    jQuery("#login-box").submit(function (e) {
        e.preventDefault();
        jQuery("body").removeClass("not-authenticated authentication-error").addClass("authenticating");
        jQuery("#submit-login").html("Signing in... <div class=\"loading-spinner\"></div>");
        jQuery(".demo-button").show();

        jQuery.ajax({
            type: "POST",
            url: auth_url + "/loginAjax",
            xhrFields: {withCredentials: true},
            crossOrigin: true,
            data: jQuery("#login-box").serialize(),
            dataType: "json",
            success: function (response) {
                if (!response.error) {
                    jQuery(".demo-button").hide();
                    jQuery('body').removeClass("not-authenticated authentication-error authenticating").addClass("authenticated");
                    jQuery("#submit-login").html(" Success <span class=\"check\">&check;</span>");
                    location.reload();
                } else {
                    jQuery("body").removeClass("not-authenticated authenticating").addClass("authentication-error");
                    jQuery("#submit-login").text("Try sign in again").show();
                    jQuery('.error').html(
                        "<p>The login credentials could not be verified, please try again or contact customer support.</p>"
                    );
                    jQuery(".demo-button").hide();
                }
            },
            error: function (xhr, status) {
                jQuery('body').removeClass("not-authenticated authenticating").addClass("authentication-error");
                jQuery("#submit-login").text("Try sign in again").show();
                jQuery(".error").html(
                    "<p>An unexpected error has occurred.</p>" +
                    "<p>Please contact us if the problem persists.</p>"
                );
                jQuery(".demo-button").hide();
            }
        })
    });
}